import { useNavigate } from "react-router-dom";
import BottomSheet from "components/common/BottomSheet";
import buyTicketImage from "assets/images/imgs/class/buy_ticket_image.png";

const BuyTicketBottomsheet = ({ isOpen, onClose, errorData = null, lessonProductId = null }) => {
    const navigate = useNavigate();
    
    // recommended_products (복수) 또는 recommended_product (단수) 처리
    // 백엔드에서 배열로 오거나 단일 객체로 올 수 있음
    let recommendedProducts = [];
    if (errorData?.recommended_products) {
        recommendedProducts = errorData.recommended_products;
    } else if (errorData?.recommended_product) {
        recommendedProducts = [errorData.recommended_product];
    }
    const hasRecommendedProducts = recommendedProducts.length > 0;
    
    // 에러 메시지에서 제목 추출
    const getTitle = () => {
        if (errorData?.code === 'RETAKE_TICKET_REQUIRED') {
            return "재수강이 필요합니다 🔄";
        }
        if (errorData?.code === 'SPECIAL_TICKET_REQUIRED') {
            return "수강권이 필요합니다 ✨";
        }
        if (errorData?.code === 'LESSON_TICKET_REQUIRED') {
            return "수강권이 필요합니다 📚";
        }
        return "사용 가능한 수강권이 없어요 😥";
    };
    
    // 상품 구매 페이지로 이동
    // productId는 명시적으로 전달된 추천 상품 ID, null/undefined 체크로 0도 허용
    const handleBuyTicket = (productId) => {
        if (productId !== null && productId !== undefined) {
            // 추천 상품 ID가 명시적으로 있는 경우 (0도 유효)
            navigate(`/class/detail/${productId}`);
        } else if (lessonProductId) {
            // 강습의 lesson_product_id가 있는 경우
            navigate(`/class/detail/${lessonProductId}`);
        } else {
            // fallback: 스토어 목록 페이지
            navigate(`/store/class`);
        }
        onClose();
    };
    
    return (
        <BottomSheet
            isOpen={isOpen}
            onClose={onClose}
            title={getTitle()}
            className="buy-class-ticket-bottom-sheet"
        >
            <div className="buy-class-ticket-bottom-sheet-content">
                {/* 기본 안내 */}
                <p>수강권을 구매하고 다이빙 여정을 시작해보세요!</p>
                
                {/* 이미지 - 항상 표시 */}
                <img src={buyTicketImage} alt="buy-ticket-image" />
                
                {/* 추천 상품이 있는 경우 */}
                {hasRecommendedProducts ? (
                    <>
                        <p>아래 수강권 중 하나를 구매해주세요:</p>
                        <div className="recommended-products">
                            {recommendedProducts.map((product) => (
                                <button
                                    key={product.id}
                                    className="btn btn-purple400 btn-medium"
                                    onClick={() => handleBuyTicket(product.id)}
                                >
                                    {product.name} 구매하기
                                </button>
                            ))}
                        </div>
                    </>
                ) : (
                    <button
                        className="btn btn-purple400 btn-medium"
                        onClick={() => handleBuyTicket(null)}
                    >
                        수강권 구매하기
                    </button>
                )}
                
                <button
                    className="btn btn-outline-purple500 btn-medium"
                    onClick={onClose}
                >
                    다음에 구매하기
                </button>
            </div>
        </BottomSheet>
    );
};

export default BuyTicketBottomsheet;